import { colors, cardShadow } from "../constants";

// Glass Card Component - Premium floating style
const GlassCard = ({ children, className = "", padding = "p-6", elevated = true }) => (
  <div
    className={`rounded-[20px] ${padding} ${className}`}
    style={{
      background: colors.cardBg,
      border: `1px solid ${colors.cardBorder}`,
      backdropFilter: "blur(20px)",
      boxShadow: elevated ? cardShadow : "none",
    }}
  >
    {children}
  </div>
);

export default GlassCard;
